import { getLiteral } from 'utils/getLiteral';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import { PAGINATION_TABLE_ENTITY } from 'constants/Environment';

export default (params) => ({
    pageSize: PAGINATION_TABLE_ENTITY,
    entity: CAMPAIGNS_MARKETING,
    quickFilters: ['statusId', 'fcreado', 'campaignStartDate', 'contacts'],
    defaultFilters: [
        'statusId',
        'auditModifiedUser',
        'fcreado',
        'fmodificado',
        'campaignStartDate',
        'contacts',
    ],
    filtersAddButtonSchema: [
        {
            label: getLiteral('action_filters'),
            options: [
                'statusId',
                'auditModifiedUser',
                'fcreado',
                'fmodificado',
                'campaignStartDate',
                'contacts',
            ],
        },
    ],
    useFiltersDrawer: true,
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('label_email_campaigns'),
            field: 'id',
            sortField: 'id',
            headerComponent: 'headerTextCell',
            headerComponentParams: {
                showTotal: true,
            },
            cellRenderer: 'marketingCampaignRow',
            minWidth: 1000,
            resizable: false,
        },
    ],
});
